// ======================================================================
// File Name       : SelectCourseDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as csvActions from '../../../actions/csvDownloadAction';
import MessageSearch from '../../../components/MessageSearch';
import ModalWrapper from '../../../components/modal/ModalWrapper';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';
import CourseList from './CourseList';
import SelectedCourseList from './SelectedCourseList';


class SelectCourseDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      checkedCourseList: [],
      checkedCourseOnModal: [],
      isAllowShowSearchMessage: false,
    };
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.handleAddCourse = this.handleAddCourse.bind(this);
    this.handleRemoveAllCourses = this.handleRemoveAllCourses.bind(this);
    this.handleRemoveCourse = this.handleRemoveCourse.bind(this);
    this.handleSearchCourse = this.handleSearchCourse.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  /**
   * Init data
   */
  componentDidMount() {
    this.props.dispatch(csvActions.initCourseList());
  }

  /**
   * Unmount component
   */
  componentWillUnmount() {
    this.props.dispatch(csvActions.unMountCourseDialog());
  }

  /**
   * Handle OK button
   */
  onOK() {
    const { addedCourseList } = this.props;
    this.props.dispatch(csvActions.addCheckedCourseToTargetList(addedCourseList));
    this.props.hideModal();
  }

  /**
   * Handle 戻る button
   */
  onCancel() {
    // Reset addedCourseList on Store
    this.props.dispatch(csvActions.reset());
    this.props.hideModal();
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-course');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  /**
   * Handle 全選択/解除 button
   */
  handleCheckAll() {
    const { targetCourse, csvDownload } = this.props;
    const { checkedCourseOnModal, checkedCourseList } = this.state;
    const checkCourseIdChecked = [];
    if (targetCourse.allSecernIds && targetCourse.allSecernIds.length) {
      targetCourse.allSecernIds.map((courseSecernId) => {
        const pos = checkedCourseOnModal.indexOf(courseSecernId);
        if (pos > -1) {
          checkCourseIdChecked.push(pos);
        }
      });

      if (checkCourseIdChecked.length === targetCourse.allSecernIds.length) {
        // uncheck all
        targetCourse.allSecernIds.map((courseSecernId) => {
          const pos = checkedCourseOnModal.indexOf(courseSecernId);
          if (pos > -1) {
            checkedCourseOnModal.splice(pos, 1);
          }
          return null;
        });
        this.setState({ checkedCourseOnModal: [...checkedCourseOnModal] });
        return;
      }
      // checkAll
      targetCourse.allSecernIds.map((courseSecernId) => {
        if (checkedCourseOnModal.indexOf(courseSecernId) < 0) {
          checkedCourseOnModal.unshift(courseSecernId);
        }
        return null;
      });
      this.setState({ checkedCourseOnModal: [...checkedCourseOnModal] });
    }
  }

  /**
   * Handle Checkbox event
   */
  handleCheckbox(event) {
    const { value } = event.target;
    const checkedCourseList = [...this.state.checkedCourseList];
    const checkedCourseOnModal = [...this.state.checkedCourseOnModal];

    const pos = checkedCourseList.indexOf(value);
    pos < 0 ? checkedCourseList.unshift(value) : checkedCourseList.splice(pos, 1);

    const pos2 = checkedCourseOnModal.indexOf(value);
    pos2 < 0 ? checkedCourseOnModal.unshift(value) : checkedCourseOnModal.splice(pos2, 1);

    this.setState({ checkedCourseList, checkedCourseOnModal });
  }

  /**
   * Handle 追加 button
   */
  handleAddCourse() {
    this.scrollToBottom();
    this.props.dispatch(csvActions.addCheckedCourseToList({ addedList: this.state.checkedCourseOnModal }));
  }

  /**
   * Handle コンテンツ一括削除 button
   */
  handleRemoveAllCourses() {
    this.setState({
      checkedCourseList: [],
      checkedCourseOnModal: [],
    }, () => {
      this.props.dispatch(csvActions.addCheckedCourseToList({ removedAll: true }));
    });
  }

  /**
   * Handle remove icon button
   */
  handleRemoveCourse(courseSecernId) {
    const { checkedCourseList, checkedCourseOnModal } = this.state;
    const pos = checkedCourseList.indexOf(courseSecernId);
    if (pos >= 0) {
      checkedCourseList.splice(pos, 1);
    }
    const pos2 = checkedCourseOnModal.indexOf(courseSecernId);
    if (pos2 >= 0) {
      checkedCourseOnModal.splice(pos2, 1);
    }
    this.setState({
      checkedCourseList, checkedCourseOnModal,
    }, () => {
      this.props.dispatch(csvActions.addCheckedCourseToList({ removedSecern: courseSecernId }));
    });
  }

  /**
   * Handle paging event
   */
  getStartEndData(startPosition) {
    const { invalid, formValues, courseSearchConditions } = this.props;
    if (invalid) return;
    if (courseSearchConditions && Object.keys(courseSearchConditions).length > 0) {
      this.props.dispatch(csvActions.searchCourse(courseSearchConditions.courseName,
        courseSearchConditions.userAttributeKeyNum, courseSearchConditions.userAttributeSearchText, startPosition));
      // #7205 START
    } else {
      this.props.dispatch(csvActions.getCourseListPaging(startPosition));
    }
  // #7205 END
  }

  /**
   * Handle search course
   */
  handleSearchCourse() {
    const { formValues } = this.props;
    const { courseName, userAttributeKeyNum, userAttributeSearchText } = formValues;

    this.props.change('startPosition', 0);
    this.props.dispatch(csvActions.searchCourse(courseName, userAttributeKeyNum, userAttributeSearchText));
    this.setState({ isAllowShowSearchMessage: true });
  }

  /**
   * Handle turn off notification message
   */
  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  /**
   * Config header and footer modal
   */
  getModalOptions() {
    return {
      title: '対象となるコースを指定してください',
      footerBtns: null,
    };
  }

  render() {
    const { userAttributeKeyNum, userAttributeSearchText, targetCourse } = this.props;
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <MessageSearch
          recordNum={targetCourse ? targetCourse.recordNum : 0}
          resultList={targetCourse ? targetCourse.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        {/* Search Form */}
        <Col sm={12} className='margin-bottom-15'>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSearchCourse();
            }}
            className='form-horizontal'
          >
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                コース名
              </Col>
              <Col sm={8} className='padding-right-15'>
                <RenderField type="text" name="courseName" maxLength="40" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <RenderField
                  type="selectbox"
                  name="userAttributeKeyNum"
                  label="ライブ開催者名"
                  value={userAttributeKeyNum}
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                  normalizeSelectBox
                />
              </Col>
              <Col sm={6} className='padding-left-15 padding-right-15'>
                <RenderField type="text" name="userAttributeSearchText" label="自由記述領域" value={userAttributeSearchText} />
              </Col>
            </Form.Group>
            <Form.Group className="text-center">
              <Col sm={12} className="margin-top-10 padding-left-right-clear">
                {/* <Button bsStyle="primary" className="btn-96" onClick={this.handleSearchCourse}>
                  search
                </Button> */}
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  handleClick={this.handleSearchCourse}
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                  type="submit"
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>

        <CourseList
          targetCourse={targetCourse}
          checkedCourseOnModal={this.state.checkedCourseOnModal}
          getStartEndData={this.getStartEndData}
          handleCheckAll={this.handleCheckAll}
          handleCheckbox={this.handleCheckbox}
          handleAddCourse={this.handleAddCourse}
        />
        <SelectedCourseList
          handleRemoveCourse={this.handleRemoveCourse}
          handleRemoveAllCourses={this.handleRemoveAllCourses}
          onCancel={this.onCancel}
          onOK={this.onOK}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authed, course, csvDownload } = state;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const formValues = getFormValues('selectCourseDialog')(state);
  const { targetCourse, addedCourseList, courseSearchConditions } = csvDownload;
  const data = {
    courseName: '',
    userAttributeKeyNum: 0,
    userAttributeSearchText: '',
  };
  return {
    formValues,
    group,
    userInfo,
    course,
    targetCourse,
    addedCourseList,
    csvDownload,
    initialValues: data,
    courseSearchConditions,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'selectCourseDialog', // a unique identifier for this form
  touchOnChange: true,
})(SelectCourseDialog));
